export default __webpack_public_path__ + "static/mentors-dfe76b5794834d5523d57e8c4769c056.webp";